import { Component, EventEmitter, Input, OnInit, Output, SimpleChange } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services';
import { UnitsService } from 'src/app/_services/units.service';

@Component({
  selector: 'app-units',
  templateUrl: './units.component.html',
  styleUrls: ['./units.component.scss']
})
  export class UnitsComponent implements OnInit {
    @Output() selectdUnits: EventEmitter<any> = new EventEmitter();
    @Input() disabled: boolean = false;
    @Input() selecteChoice;
    @Input() component = "default";
    @Input() CompanyId;
    myControl = new FormControl();
    options: any[] = []
    filteredOptions: Observable<any[]>;
    isloading = false;

    constructor(private units: UnitsService,
                private authenticationService: AuthenticationService
               ){ }

    ngOnInit() {
      let user = this.authenticationService.currentUserValue as any;
      console.log('selecteChoice id ',this.selecteChoice)
      this.CompanyId = user.company_id;
      this.myControl.setValue(this.selecteChoice);
      this.getUnits(this.CompanyId);
      this.filteredOptions = this.myControl.valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))
        );
    }

    ngOnChanges(changes: { [property: string]: SimpleChange }) {
      let change: SimpleChange = changes['CompanyId'];
      if (change?.currentValue) {
        this.getUnits(change?.currentValue)
      }
      let change2: SimpleChange = changes['selecteChoice'];
      if (change2?.currentValue) {
        this.selecteChoice = change2?.currentValue;
        this.myControl.setValue(this.selecteChoice);
        console.log('selecteChoice id ',change2?.currentValue)
      }
    }

    private _filter(value: string): string[] {
      const filterValue = value.toLowerCase();
      return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
    }

    async getUnits(CompanyId) {
      this.isloading = true;
      (await this.units.getAllUnits(CompanyId)).subscribe((response: any) => {
        this.options = response.vehicles;
        this.isloading = false;
        if (this.options.length === 0) {
          this.myControl.setValue("La table des véhicules est vide");
        }
      })
    }
    selectedCardata(data) {
      this.selectdUnits.emit(data);
    }
  }
